import { noop } from '../../../../../lib/utilities';
import React from 'react';
import PropTypes from 'prop-types';
import { AllItemsPrice } from './all_items_price';
// TODO: Temporary disabled matesrates
import { AllItemsPriceMatesRates } from './all_items_price_mates_rates';
import { Products } from './products';

export const AllItems = ( {
    products,
    showDetails,
    currencyIsoCode,
    allItemsPrice,
    onMatesRatesLearnMoreClick,
    onShowProductDetailsClick,
    shouldDisplayMatesRates,
    cartProducts,
    shipments,
}) => [
    <AllItemsPrice
        price={allItemsPrice}
        currencyIsoCode={currencyIsoCode}
        hasMatesRates={shouldDisplayMatesRates}
        key="AllItemsPrice"
    />,
    // shouldDisplayMatesRates &&
    //     <AllItemsPriceMatesRates
    //         price={allItemsPrice / 2}
    //         currencyIsoCode={currencyIsoCode}
    //         onMatesRatesLearnMoreClick={onMatesRatesLearnMoreClick}
    //         key="AllItemsPriceMatesRates"
    //     />,
    <Products
        products={products}
        showDetails={showDetails}
        currencyIsoCode={currencyIsoCode}
        onShowProductDetailsClick={onShowProductDetailsClick}
        cartProducts={cartProducts}
        shipments={shipments}
        key="Products"
    />,
];

AllItems.propTypes = {
    allItemsPrice: PropTypes.number.isRequired,
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    showDetails: PropTypes.bool.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onMatesRatesLearnMoreClick: PropTypes.func.isRequired,
    onShowProductDetailsClick: PropTypes.func,
    shouldDisplayMatesRates: PropTypes.bool.isRequired,
    cartProducts: PropTypes.arrayOf(PropTypes.object),
};

AllItems.defaultProps = {
    onShowProductDetailsClick: noop,
    cartProducts: [],
};
